export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 rounded-full bg-primary-100/50 blur-3xl"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="w-full">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-fire-line"></i>
              热剧在线观看 · 追剧指南
            </span>

            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
              韩剧TV
              <span className="mt-2 block text-primary-600">在线观看与追剧指南</span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-700 md:text-base">
              这里整理了与韩剧在线观看相关的浏览线索：按类型挑选剧目、了解网页版入口与手机在线看的差异、
              掌握周更节奏，再配合一份实用的追剧攻略。无论你是想在电脑上大屏追剧，还是用手机利用碎片时间看两集，
              都能在本页找到对应的参考信息。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-film-line"></i>
                浏览热门推荐
              </a>
              <a
                href="#guide"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-background-100"
              >
                <i className="ri-guide-line"></i>
                查看观看指南
              </a>
            </div>

            <dl className="mt-9 grid max-w-lg grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-3">
              <div>
                <dt className="text-xs text-foreground-600">浏览重点</dt>
                <dd className="mt-1 text-sm font-semibold text-foreground-950">在线观看 / 手机在线看</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-600">内容形式</dt>
                <dd className="mt-1 text-sm font-semibold text-foreground-950">类型分区 + 追剧攻略</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-600">适用场景</dt>
                <dd className="mt-1 text-sm font-semibold text-foreground-950">电脑大屏 / 手机通勤</dd>
              </div>
            </dl>
          </div>

          <div className="relative w-full">
            <div className="relative mx-auto h-[380px] w-full max-w-md overflow-hidden rounded-lg bg-background-200 md:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20scene%20inspired%20by%20Korean%20drama%2C%20elegant%20silhouette%20of%20a%20person%20by%20a%20rainy%20window%20at%20dusk%2C%20warm%20amber%20and%20coral%20color%20tones%2C%20soft%20bokeh%20lights%2C%20moody%20yet%20romantic%20atmosphere%2C%20editorial%20film%20photography%20style%2C%20refined%20and%20minimal%20composition&width=960&height=1200&seq=hdrama-hero-01&orientation=portrait"
                alt="韩剧TV 在线观看相关氛围配图"
                title="韩剧TV 在线观看与追剧指南"
                className="h-full w-full object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 rounded-lg bg-background-50/90 px-4 py-3 backdrop-blur">
                <p className="flex items-center gap-2 text-xs font-medium text-primary-700">
                  <i className="ri-bookmark-3-line"></i>
                  今日追剧清单 · 按类型挑选
                </p>
                <p className="mt-1 text-sm font-semibold text-foreground-950">
                  从悬疑到治愈，9 部精选剧目任意切换
                </p>
              </div>
            </div>

            <div className="absolute -left-3 top-8 hidden rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:block">
              <p className="text-xs text-foreground-600">观看方式</p>
              <p className="mt-0.5 text-sm font-semibold text-foreground-950">网页 · 手机 · 在线播放</p>
            </div>
            <div className="absolute -right-3 bottom-16 hidden rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:block">
              <p className="text-xs text-foreground-600">更新节奏</p>
              <p className="mt-0.5 text-sm font-semibold text-accent-700">周更追剧 · 完结连看</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}